import React, { ChangeEvent, useEffect, useRef, useState } from "react";
import { useCombinedStore } from "../store";
import Modal from "react-modal";
import MessageBox from "./MessageBox";
import api from "../services/api.service";
import * as Styles from "../styles/ReviewOrderTax.Modal.styles";
import alfredoIcon from "../assets/alfredo-icon.svg";

interface SendToDeliveryModalProps {
  isOpen: boolean;
  onRequestClose: () => void;
  setSearchValueInput: (value: string) => void;
  setCustomerInfoByOrder: (value: any) => void;
}

const SendToDeliveryModal: React.FC<SendToDeliveryModalProps> = ({
  isOpen,
  onRequestClose,
  setSearchValueInput,
  setCustomerInfoByOrder,
}) => {
  const {
    subsidiaryDataZustand,
    setOrderDataZustand,
    orderDataZustand,
    authUserZustand,
    setMessageZustand,
  } = useCombinedStore((state) => {
    return {
      setSubsidiaryDataZustand: state.setSubsidiaryDataZustand,
      subsidiaryDataZustand: state.subsidiaryDataZustand,
      setOrderDataZustand: state.setOrderDataZustand,
      orderDataZustand: state.orderDataZustand,
      setMessageZustand: state.setMessageZustand,
      authUserZustand: state.authUserZustand,
    };
  });
  const modalWrapperRef = useRef<HTMLDivElement>(null);

  const [deliveryMans, setDeliveryMans] = useState<any>(null);

  useEffect(() => {
    const firstDeliveryMan =
      subsidiaryDataZustand.selectedPdv.selectedPeriod.periodInfo?.periodDeliveryMans?.DeliveryMans?.[0];
    if (firstDeliveryMan) {
      setDeliveryMans(firstDeliveryMan);
    }
  }, [subsidiaryDataZustand]);

  const handleChange = (event: ChangeEvent<HTMLSelectElement>) => {
    const selectDeliveryMan =
      subsidiaryDataZustand.selectedPdv.selectedPeriod.periodInfo?.periodDeliveryMans?.DeliveryMans?.find(
        (deliveryMan: any) => deliveryMan.userUuid === event.target.value
      );
    setDeliveryMans(selectDeliveryMan || null);
  };

  const handleSubmit = async () => {
    if (deliveryMans) {
      try {
        const sendToDeliveryResponse = await api.patch(
          `order/${orderDataZustand.orderUuid}`,
          {
            orderStatus: 4,
            deliveryManUuid: deliveryMans.userUuid,
          }
        );
        if (
          sendToDeliveryResponse.status === 200 ||
          sendToDeliveryResponse.status === 201
        ) {
          setMessageZustand(`Pedido enviado com sucesso!`, `success`);
          setSearchValueInput("");
          setOrderDataZustand({
            orderUuid: "",
            orderCode: "",
            orderOwnerUuid: "",
            orderOwnerName: "",
            orderStatus: 0,
            orderType: "",
            createdAt: "",
            orderInfo: {},
          });
          setCustomerInfoByOrder({
            customerName: "",
            customerAddress: "",
            customerAddressComplement: "",
            customerAddressObservation: "",
            customerOrigin: "",
            customerPhone: "",
          });
          onRequestClose();
        }
      } catch (error: any) {
        if (error.message === "Network Error") {
          setMessageZustand(
            `Erro ao tentar enviar a conta, entre em contato com os administradores do Alfredo da sua unidade.`,
            `error`
          );
        } else {
          setMessageZustand(
            `Erro ao enviar a conta: ${error.message}`,
            `error`
          );
        }
      }
    } else {
      setMessageZustand(`Selecione um entregador disponível.`, `error`);
    }
  };

  useEffect(() => { }, [setOrderDataZustand, orderDataZustand]);

  const handleKeyDown = async (
    event: React.KeyboardEvent<HTMLInputElement>
  ) => {
    if (event.key === "Enter") {
      await handleSubmit();
    }
  }

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={() => onRequestClose()}
      style={Styles.customStyles}
      contentLabel="Main Modal"
      ariaHideApp={false}
    >
      <MessageBox />
      <Styles.ModalWrapper
        tabIndex={-1}
        ref={modalWrapperRef}
        onKeyDown={handleKeyDown}
      >
        <Styles.CloseButton onClick={() => onRequestClose()}>
          &times;
        </Styles.CloseButton>
        <Styles.ModalContent>
          <Styles.ModalHeader
            color={
              subsidiaryDataZustand.selectedPdv.homeInfo.itemInfoValue
                .buttonsColor
            }
          >
            <Styles.Logo src={alfredoIcon} alt="Alfredo Web OPS" />
            <Styles.ModalTitle>
              Envie o pedido para o cliente.
            </Styles.ModalTitle>
          </Styles.ModalHeader>
          <Styles.ModalBody
            color={
              subsidiaryDataZustand.selectedPdv.homeInfo.itemInfoValue
                .backgroundColor
            }
          >
            <Styles.RowContainer>
              <Styles.FieldLabel>
                Selecione o entregador que fará a entrega:
              </Styles.FieldLabel>
              <Styles.DropdownInput
                color={
                  subsidiaryDataZustand.selectedPdv.homeInfo.itemInfoValue
                    .buttonsColor
                }
              >
                <select onChange={handleChange}>
                  {subsidiaryDataZustand.selectedPdv.selectedPeriod.periodInfo?.periodDeliveryMans?.DeliveryMans.map(
                    (deliveryMan: any, index: number) => (
                      <option key={index} value={deliveryMan.userUuid}>
                        {deliveryMan.userSocialName}
                      </option>
                    )
                  )}
                </select>
                <label>Entregadores</label>
              </Styles.DropdownInput>
            </Styles.RowContainer>
          </Styles.ModalBody>
          <Styles.ModalFooter
            color={
              subsidiaryDataZustand.selectedPdv.homeInfo.itemInfoValue
                .buttonsColor
            }
          >
            <Styles.Button onClick={() => onRequestClose()}>
              Cancelar
            </Styles.Button>
            <Styles.Button onClick={handleSubmit}>Enviar</Styles.Button>
          </Styles.ModalFooter>
        </Styles.ModalContent>
      </Styles.ModalWrapper>
    </Modal>
  );
};

export default SendToDeliveryModal;
